"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// import config from "../BaseConfig";
const Environment_1 = require("../../models/Environment");
const prodConfig = {
    env: Environment_1.BuildEnvironment.Prod,
    publicPath: "https://statics.teams.microsoft.com",
};
exports.default = prodConfig;
